"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const react_i18next_1 = require("react-i18next");
const RedeemModalConfirmationStyle_1 = require("../jss/RedeemModalConfirmationStyle");
const RewardCouponModal_1 = require("../RewardCouponModal");
const handleDownload = async (downloadUrl, rewardTitle) => {
    const image = await fetch(downloadUrl);
    const imageBlob = await image.blob();
    const imageURL = URL.createObjectURL(imageBlob);
    const link = document.createElement('a');
    link.href = imageURL;
    link.download = `${rewardTitle}_${Date.now()}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const Modal = (props) => ((0, jsx_runtime_1.jsx)(RewardCouponModal_1.default, Object.assign({}, props, { handleDownload: handleDownload })));
exports.default = (0, styles_1.withStyles)(RedeemModalConfirmationStyle_1.default)((0, react_i18next_1.withTranslation)()(Modal));
//# sourceMappingURL=RewardCouponModalV2.js.map